import { Column } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';

import {
  BiodiversityZoneCell,
  CarbonStorageBgCell,
  PlotRow,
  WaterHoldingCapacityCell,
} from '@/pages/shared/projects/pages/project/pages/sustainableProduction/pages/plots/components/Cells';

import { ProjectTypeAccessorKey } from '../../projects/pages/project/pages/sustainableProduction/components/plot-list/constants';
import { ToggleSortButton } from '../../projects/pages/project/pages/sustainableProduction/components/plot-list/ToggleSortButton';

type CellHeader = {
  column: Column<PlotRow, unknown>;
};

export const useGetCustomCells = () => {
  const { t } = useTranslation();
  return [
    {
      accessorKey: ProjectTypeAccessorKey.biodiversityZone,
      header: ({ column }: CellHeader) => (
        <ToggleSortButton column={column} className='-ml-2.5'>
          {t('shared.plots.tableHeader.protectedHabitat')}
        </ToggleSortButton>
      ),
      cell: BiodiversityZoneCell,
    },
    {
      accessorKey: ProjectTypeAccessorKey.carbonStorageBg,
      header: ({ column }: CellHeader) => (
        <ToggleSortButton column={column} className='-ml-2.5'>
          {t('shared.plots.tableHeader.carbonStorageBG')}
        </ToggleSortButton>
      ),
      cell: CarbonStorageBgCell,
    },
    {
      accessorKey: ProjectTypeAccessorKey.waterHoldingCapacity,
      header: ({ column }: CellHeader) => (
        <ToggleSortButton column={column} className='-ml-2.5'>
          {t('shared.plots.tableHeader.waterHoldingCapacity')}
        </ToggleSortButton>
      ),
      cell: WaterHoldingCapacityCell,
    },
  ];
};
